import React, { createContext, useState, useContext } from "react";
import PropTypes from "prop-types";

const SearchContext = createContext();

export const useInputSearchContext = () => useContext(SearchContext);

const InputSearchProvider = ({ children }) => {
	const [values, setValues] = useState({
		from: null,
		defaultPort: null,
		calendarDates: null,
		defaultGateway: null,
		defaultCruiseTo: null,
		defaultShipLine: null,
		defaultCruiseMonth: null,
		defaultRoomsAndGuests: null,
		
		cruiseToData: [],
		cruiseLineData: [],
		cruisePortData: [],

		toFieldData: [],
	});

	const storeSearchValues = newValue => {
		switch (newValue.type) {
			case "from":
				setValues(prev => ({ ...prev, from: newValue.from }));
				break;

			case "defaultShipLine":
				setValues(prev => ({ ...prev, defaultShipLine: newValue.defaultShipLine }));
				break;

			case "defaultPort":
				setValues(prev => ({ ...prev, defaultPort: newValue.defaultPort }));
				break;

			case "defaultDuration":
				setValues(prev => ({ ...prev, defaultDuration: newValue.defaultDuration }));
				break;

			case "defaultCruiseMonth":
				setValues(prev => ({ ...prev, defaultCruiseMonth: newValue.defaultCruiseMonth }));
				break;

			case "calendarDates":
				setValues(prev => ({ ...prev, calendarDates: newValue.calendarDates }));
				break;

			case "defaultGateway":
				setValues(prev => ({
					...prev,
					defaultGateway: newValue.defaultGateway,
				}));
				break;

			case "defaultCruiseTo":
				setValues(prev => ({
					...prev,
					defaultCruiseTo: newValue.defaultCruiseTo,
				}));
				break;
			
			case "toFieldData":
				setValues(prev => ({ ...prev, toFieldData: newValue.toFieldData }));
				break;
			
			case "cruiseToData":
				setValues(prev => ({
					...prev,
					cruiseToData: newValue.cruiseToData,
				}));
				break;
			
			case "cruiseLineData":
				setValues(prev => ({
					...prev,
					cruiseLineData: newValue.cruiseLineData,
				}));
				break;

			case "cruisePortData":
				setValues(prev => ({
					...prev,
					cruisePortData: newValue.cruisePortData,
				}));
				break;

			case "defaultRoomsAndGuests":
				setValues(prev => ({
					...prev,
					defaultRoomsAndGuests: newValue.defaultRoomsAndGuests,
				}));
				break;

			default:
				break;
		}
	};

	return (
		<SearchContext.Provider value={{ values, storeSearchValues }}>
			{children}
		</SearchContext.Provider>
	);
};

InputSearchProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export { InputSearchProvider };
